import { FlowParameterParams } from '~src/flow/types/FlowParameters';
import { SelfServiceSchedule } from '~src/schedule/serverApi/types/SelfServiceSchedule';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';
import { SubscriptionFlow } from '../types/SubscriptionFlow';

export interface CreateRunFlowTaskSelfServiceSchedulesParams {
  readonly schedule: SelfServiceSchedule;
  readonly flowId: string;
  readonly runAllOutputs: boolean;
  readonly isRunAllIncremental: boolean;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
  readonly sendEmailWhenDone: boolean;
  readonly subscriptionFlow?: SubscriptionFlow;
  readonly parameterParams?: FlowParameterParams[];
}

export class CreateRunFlowTaskSelfServiceSchedulesRequest extends Request<CreateRunFlowTaskSelfServiceSchedulesParams, IResult> {
  constructor(params: CreateRunFlowTaskSelfServiceSchedulesParams) {
    super('createRunFlowTaskSelfServiceSchedules', params);
  }
}
